import { combineReducers } from "redux";
import updates from "./updates";

export default combineReducers({ updates });
